import { all, fork } from "redux-saga/effects";

// import wallet from './wallet';

export default function* submit() {
  yield all([
    // fork(wallet),
  ]);
}
